var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`${_vm.type} ${_vm.size} ${_vm.round ? 'roundTag' : ''} ${_vm.className}`},[(_vm.$slots.value)?_vm._t("value"):_c('span',[_vm._v(" "+_vm._s(_vm.value)+" ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }